<template>
  <div class="margin-left-5" style="display: inline-flex;">
    <b-card bg-variant="warning" class="padding-half">
      <h5 class="btm-zero">商品登録エラーの対応方法はこちらでご確認下さい　⇒　<a size="sm" :href="link()" target="_blank">　リンク　</a></h5>
    </b-card>
  </div>
</template>

<script>
export default {
  methods: {
    link() {
      return 'https://docs.google.com/presentation/d/1P4PzseHLSXF_Ml86VzxBeDRP9eFUb_kfffclg0Vgw4Y/edit#slide=id.p';
    }
  },
};
</script>

<style scoped>
a {
    text-decoration-line: underline;
    color: red;
    font-weight: bold;
}
.card > .card-body {
    padding: 0.5rem;
    text-align: center;
}
h5{
  font-size: 1rem;
}
.btm-zero {
    margin-bottom: 0;
    line-height: 1.5;
}

</style>